import React, { useState, useEffect } from "react";
import { Space, Typography } from "antd";
import UTCDatePicker from "./UTCDatePicker";
import UTCTimePicker from "./UTCTimePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 加载dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

const { Text } = Typography;

/**
 * UTC日期时间选择器组件
 * 组合日期选择器和时间选择器，强制以UTC时区显示和处理
 */
const UTCDateTimePicker = ({ value, onChange, dateFormat = "YYYY-MM-DD", timeFormat = "HH:mm", style, disabled = false, showLabel = true }) => {
    // 拆分成日期和时间两部分状态
    const [dateValue, setDateValue] = useState(null);
    const [timeValue, setTimeValue] = useState(null);

    // 当外部value变化时，更新内部状态
    useEffect(() => {
        if (value) {
            const utcDateTime = dayjs.utc(value);
            if (utcDateTime.isValid()) {
                setDateValue(utcDateTime);
                setTimeValue(utcDateTime);
            }
        } else {
            setDateValue(null);
            setTimeValue(null);
        }
    }, [value]);

    // 处理日期变化
    const handleDateChange = (date) => {
        setDateValue(date);
        updateCombinedValue(date, timeValue);
    };

    // 处理时间变化
    const handleTimeChange = (time) => {
        setTimeValue(time);
        updateCombinedValue(dateValue, time);
    };

    // 更新组合后的日期时间值并调用外部onChange
    const updateCombinedValue = (date, time) => {
        if (!date && !time) {
            onChange && onChange(null);
            return;
        }

        try {
            // 如果只有日期没有时间，默认为当天的00:00 UTC
            if (date && !time) {
                const combinedDateTime = date.startOf("day");
                onChange && onChange(combinedDateTime);
                return;
            }

            // 如果只有时间没有日期，默认使用今天的日期
            if (!date && time) {
                const today = dayjs.utc().startOf("day");
                const combinedDateTime = today.hour(time.hour()).minute(time.minute()).second(0);
                onChange && onChange(combinedDateTime);
                return;
            }

            // 正常情况：合并日期和时间
            const combinedDateTime = date.hour(time.hour()).minute(time.minute()).second(0);

            onChange && onChange(combinedDateTime);
        } catch (error) {
            console.error("合并日期和时间出错:", error);
        }
    };

    return (
        <Space direction="vertical" style={{ width: "100%", ...style }}>
            {showLabel && (
                <Text strong style={{ display: "block" }}>
                    日期 (UTC)
                </Text>
            )}
            <UTCDatePicker value={dateValue} onChange={handleDateChange} format={dateFormat} disabled={disabled} />

            {showLabel && (
                <Text strong style={{ display: "block", marginTop: 8 }}>
                    时间 (UTC)
                </Text>
            )}
            <UTCTimePicker value={timeValue} onChange={handleTimeChange} format={timeFormat} disabled={disabled} />
        </Space>
    );
};

export default UTCDateTimePicker;
